export function scrollChildIntoView(
	container: HTMLElement,
	childIndex: number
) {
	if (container.scrollWidth > container.offsetWidth) {
		try {
			const child = container.children[childIndex] as HTMLElement;
			const maxAllowedLeft =
				container.scrollWidth - container.offsetWidth;
			const centeredChildLeft =
				child.offsetLeft -
				Math.floor((container.offsetWidth - child.offsetWidth) / 2);
			const updLeft = Math.min(
				Math.max(0, centeredChildLeft),
				maxAllowedLeft
			);
			container.scrollTo({ left: updLeft, behavior: "smooth" });
		} catch (error) {
			console.log("centered nav tabs scrolling failed");
		}
	}
}
